import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { SupportService } from 'src/app/services/core/support/support.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { debounceTime, forkJoin,filter, Subject } from 'rxjs';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { UserPermission } from 'src/app/enums/enums';
import { FilterPipe } from 'src/app/pipes/list-filter-pipe/list-filter-pipe';
import { CsvService } from 'src/app/services/core/csv-service/csv.service';


@UntilDestroy()
@Component({
  selector: 'app-trip-list',
  templateUrl: './trip-list.component.html',
  styleUrls: ['./trip-list.component.css']
})
export class TripListComponent implements OnInit, OnDestroy {
  isTripDetailModal: boolean = false;
  selectedTrips: any = [];
  tripId: any;
  isDistributionModal = false;
  search: any;
  trips: any = [];
  spacetypes: any;
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  preAppointmentType: any = {};
  preLevelOfService: any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  selectedStatus: any = 'pending';
  todayDate: any = [];
  startDate: any;
  endDate: any;
  levelofservices: any;
  serviceAreas: any;
  selectedServiceArea: any = ''
  selectedSpaceType: any = ''
  cancelTripObj: any;
  memberNotesObj: any;
  tripStatus: any;
  isMultiCancelModal = false;
  selectedDropdownIndex: any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user: any;
  timeZone: any = timeZone;
  currentDate: any = moment().tz(this.timeZone).toISOString()
  tripDistributionModalObj: any;
  singleTrip: any;
  isAutoDistributionModal: any;
  userPermission = UserPermission;
  filterdataList: any = [];
  private searchSubject = new Subject<string>();
  pendingTripCancelModalObj: any;
  selectedPendingStatus: any = '';

  constructor(
    private supportService: SupportService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private credentialService: CredentialService,
    private levelOfService: LosService,
    private appointmentService: AppointmentTypeService,
    private SpaceTypeService: SpaceTypeService,
    private tripService: TripService,
    private router: Router,
    public permissionService: PermissionService,
    private csvService: CsvService,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.setupFragment(); // calling order matters
    this.getUser();
    this.initializeSearch();
  }

  setupFragment() {
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      this.selectedStatus = fragment;
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        fragment: this.selectedStatus
      });
    }
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (!fragment) {
          // case: trips menu is already activated and it is clicked again in the sidenav
          this.filterTrips("pending");
        } else {
          // case: click on the trip notification in notification modal
          if (this.selectedStatus !== fragment) {
            this.filterTrips(fragment);
          }
        }
      });
    }, 1000);
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone =  this.user.timeZone; 

        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }

    })
  }

  loadInitialData() {
    const queryparams = {
      isActive: true,
      limit : 9999
    }
    forkJoin({
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      spaceTypes: this.SpaceTypeService.getPicker({ ...queryparams, isActive: true }),
      serviceAreas: this.serviceArea.getPicker({ ...queryparams, isActive: true })
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, spaceTypes, serviceAreas }: any) => {

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips 
        this.getAllTrips(this.currentPage);
      });
  }


  getAllTrips(page: any) {
    this.clear();
    let queryparams :any=  {
      limit: this.numberOfRecords,
      page,
      status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'pickup.time:asc',
      spaceType: this.selectedSpaceType,
      serviceArea: this.selectedServiceArea
    }
    if (this.selectedStatus === 'all') {
      queryparams.status = [
        'pending',
        'scheduled',
        'offered',
        'completed',
        'cancelled',
        'onway',
        'arrived',
        'in_progress',
        'marketplace',
        'reroute'
      ];
    } else {
      queryparams.status = this.selectedStatus;
    }
     if (this.search) {
      queryparams.search = this.search.trim();
    }
    if (this.selectedStatus === 'pending' && this.selectedPendingStatus) {
      queryparams.pendingStatus = this.selectedPendingStatus;
    }
    this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
           this.trips = data.results;
          this.filterdataList = this.trips;
          this.tripStatus = this.trips && this.trips.length ? this.trips[0].status : '';
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

    getPageCount() {
    const length = this.filterdataList.length;
    const count = (this.numberOfRecords * this.currentPage) - (length !== this.numberOfRecords ? (this.numberOfRecords - length) : 0);
    return `${count} of ${this.totalResults}`;
  }



  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
      if (!this.selectedTrips.length) {
        this.isDropdownOpen = false;
      }
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
      if (this.selectedTrips.length) {
        this.isDropdownOpen = true;
      }
    }
      this.autoToggleDropdown();

  }

  onSelectAllTrips(event: any) {
    const checked = event.target.checked;
    this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
    this.selectedTrips = checked ? [...this.filterdataList] : [];
   this.autoToggleDropdown();
  }

  autoToggleDropdown() {
  // Auto open if at least 1 selected
  if (this.selectedTrips.length > 0) {
    this.isDropdownOpen = true;
  } else {
    this.isDropdownOpen = false;
  }
}

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  raiseTicket(trip: any) {
    this.supportService.raiseTicket('trip', trip.id);
  }

  openDistributionModal(evt?: any) {
    if (evt) {
      this.selectedTrips = [evt];
    } else {
      this.selectedTrips = this.trips.filter((trip: any) => trip.isSelected);
    }
    this.isDistributionModal = true;
  }

  closeModal() {
    this.isDistributionModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  openMultiCancelModal(evt?: any) {
    if (evt) {
      this.selectedTrips = [evt];
    } else {
      this.selectedTrips = this.trips.filter((trip: any) => trip.isSelected);
    }
    this.isMultiCancelModal = true;
  }

  closeMultiCancelModal() {
    this.isMultiCancelModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  openCancelModal(trip: any) {
    this.cancelTripObj = trip;
  }

  onCancelTrip(evt: any[]) {
    if (evt.length) {
      this.trips = this.trips.filter(
        (trip: any) => !evt.includes(trip.id)
      );
      this.filterdataList = this.trips;
    }
    this.singleTrip = null;
    this.cancelTripObj = null;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  onUpdateTrip(evt: any) {
    const selectedTrips = this.selectedTrips.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
    let index;
    for (let item of evt.tripsIds) {
      index = this.trips.findIndex((trip: any) => trip.id === item)
      let modifiedTrip = selectedTrips[item]
      if (evt.source === 'assign') {
        if (selectedTrips[item].company) {
          modifiedTrip = {
            ...modifiedTrip,
            company: evt.company
          }
          this.trips[index] = modifiedTrip;
        } else {
          modifiedTrip = {
            ...modifiedTrip,
            company: evt.company
          }
          this.trips.splice(index, 1)
        }
      }
      else {
        this.trips.splice(index, 1)
      }

    }
    this.isDistributionModal = false;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.getAllTrips(this.currentPage);
  }

  filterTrips(status?: string) {
    this.currentPage = 1;
    this.selectedStatus = status || '';
    this.getAllTrips(this.currentPage);
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: status
    });
  }

  clear() {
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  onCompanyChange() {
    this.getAllTrips(this.currentPage);
  }

  onServiceAreaChange() {
    this.getAllTrips(this.currentPage);
  }

  onPendingStatusChange(){
    this.currentPage = 1
    this.getAllTrips(this.currentPage);
  }

  onSpaceTypeChange() {
    this.getAllTrips(this.currentPage);
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  sendtoMarketPlace(event: any, index: any) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

  sendBulktoMarketPlace() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, selectedTripIds);
      }
    });

  }

  apiRequest(payload: any, selectedTripIds: any) {
    this.tripService.sendtoMarketPlace(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        selectedTripIds.forEach((id: number) => {
          const index = this.trips.findIndex((trip: any) => trip.id === id);
          if (index !== -1) {
            this.trips.splice(index, 1);
          }
          this.closeActionMenu(null);
        });
        this.selectedTrips = [];
      }
    });
  }

  backtoSchedule(event: any, index: any,) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "scheduled"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

  bulkBacktoSchedule() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          status: "scheduled"
        };
        this.apiRequest(payload, selectedTripIds);
      }
    });

  }

  preTripCompany() {
    const previousAssignedCompanies = this.selectedTrips
      .filter((trip: any) => trip.company)
      .map((trip: any) => ({
        company: trip.company,
        tripId: trip.id
      }));
    return previousAssignedCompanies;
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  closeFilterDropDown(evt: any) {
    this.isDropdownOpen = false
  }

  //  closeMenu(evt:any) {
  //   this.isDropdownOpen = false;
  // }

  editTrip(evt: any) {
    if (this.selectedStatus === 'all') {
      this.router.navigate(
        [`trips/${evt.id}/edit`],
        { state: { section: 'all' } }
      );
    } else { 
      this.router.navigate([`trips/${evt.id}/edit`]);
    }
  }
  toggleDropdown(event: Event) {
  event.stopPropagation();
  this.isDropdownOpen = !this.isDropdownOpen;
}


  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }

  ngOnDestroy(): void {
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }

  assignSingleTrip(trip: any) {
    this.singleTrip = [trip];
    this.isDistributionModal = true;
  }

  onAssignSingleTrip(evt: any) {
    const trip = this.singleTrip[0];
    const idx = this.trips.findIndex((trip: any) => trip.id === trip.id);

    if (evt.source === 'assign' && trip.company) {
      // Reassign
      this.trips[idx].company = evt.company;
    } else {
      // Assign/Unassign
      this.trips.splice(idx, 1);
    }

    this.singleTrip = null;
    this.isDistributionModal = false;
    this.isDropdownOpen = false;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  openAutoDistributionModal(event?: any) {
    this.isAutoDistributionModal = true
    if (event) {
      this.singleTrip = [event];
    }
  }

  closeAutoDistributionModal() {
    this.singleTrip = null;
    this.isAutoDistributionModal = false;
  }

  cancelSignleTrip(trip: any) {
    this.singleTrip = [trip];
    this.isMultiCancelModal = true;
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  tripDetailFile() {
    let selectedTrip;
    if (!this.selectedTrips.length)
      selectedTrip = this.trips;
    else
      selectedTrip = this.getSelectedTrips();

    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone, this.preLevelOfService, this.preSpacetypes, this.preServiceAreas)
  }

  openPendingCancelModal(singleTrip?: any) {
    // it handled both single and bulk trip scheduling
    if (singleTrip) {
      this.pendingTripCancelModalObj = {
        isBulkUpdate: false,
        tripIds: [singleTrip.id] 
      };
    } else {
      this.pendingTripCancelModalObj = {
        isBulkUpdate: true,
        tripIds: this.selectedTrips
          .filter((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus))
          .map((trip: any) => trip.id)
      };
    }
  }

  onClosePendingCancelModal(data: any) {
    if (data) {
      const { isBulkUpdate, tripIds } = this.pendingTripCancelModalObj;
      const { statusUpdate, changeReasonNotes } = data;
      const { skippedTrips } = statusUpdate;

      this.filterdataList.forEach((trip: any) => {
        if (tripIds.includes(trip.id) && !skippedTrips.includes(trip.id)) {
          trip.pendingStatus = 'cancelled'
          trip.changeReasonNotes = changeReasonNotes
        }
      });
      if (isBulkUpdate) {
        this.isDropdownOpen = false;
        this.selectedTrips = [];
        this.uncheckTrips();
      }
    }
    this.pendingTripCancelModalObj = null;
  }

  isPendingTripEligibleForCancel() {
    return this.selectedTrips.some((trip: any) => ['initiated', 're-offered'].includes(trip.pendingStatus)); 
  }

  async reOfferTrips(singleTrip?: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to re-offer ${singleTrip ? "this trip" : "these trips"}?`,
      "warning",
      "Yes",
      "No"
    );
    if (!result.value) return;

    let tripIds: any = [];
    if (singleTrip) {
      tripIds = [singleTrip.id]
    } else {
      tripIds = this.selectedTrips
        .filter((trip: any) => trip.pendingStatus === 'rejected')
        .map((trip: any) => trip.id)
    }

    const payload = {
      status: 're-offered',
      selectedIds: tripIds,
    }
    this.tripService
      .updatePendingTripStatus(payload)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          const { statusUpdate } = data;
          const { skippedTrips } = statusUpdate;

          this.filterdataList.forEach((trip: any) => {
            if (tripIds.includes(trip.id) && !skippedTrips.includes(trip.id)) {
              trip.pendingStatus = 're-offered'
            }
          });
          if (!singleTrip) {
            // clear for bulk update
            this.isDropdownOpen = false;
            this.selectedTrips = [];
            this.uncheckTrips();
          }
        }
      });
  }

  isPendingTripEligibleForReoffer() {
    return this.selectedTrips.some((trip: any) => trip.pendingStatus === 'rejected'); 
  }
}
